export default __webpack_public_path__ + "static/media/star4.baeaee3c.mp3";